import { render, staticRenderFns } from "./Exnews-edit.vue?vue&type=template&id=233261b3&scoped=true&"
import script from "./Exnews-edit.vue?vue&type=script&lang=js&"
export * from "./Exnews-edit.vue?vue&type=script&lang=js&"
import style0 from "./Exnews-edit.vue?vue&type=style&index=0&id=233261b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233261b3",
  null
  
)

export default component.exports